<div class="row clearfix">
    <!-- Header graphic -->
    <div class="col-sm-12">
        <div class="gdpr-header-graphic"><span i18n>Access your data preferences</span></div>
      </div>
     <!-- / End Header graphic -->
  <div class="col-sm-12 gdpr-content-area">
      <div class="container col-sm-12" style="background: transparent;">
        <div class="card card-alert" >
            <div class="card-head">
                <span><img src="assets/icon_warning.svg" alt="warning" width="25" i18n><span style="font-weight: bold;" i18n>You have entered a verification code that our system does not recognize.</span></span>
            </div>
          <div class="card-body">
              <p i18n>The most common cause is a mistyped character and be advised the codes are case-sensitive. Please check the verification code and try again. Your code may have expired. If this is the case please contact IHS Markit Support <a href="mailto:data.preferences@ihsmarkit.com" style="text-decoration: none;">here</a>.</p>
             <a href="index.html" class="alertbutton w-button btn btn-primary" style=" position:relative; left:45%; "><small style="vertical-align: text-top;" i18n>OK</small></a>
          </div>
        </div>
      </div>
      <!-- / End Error Code Messages -->

      <!-- Code validation section -->
      <form>
          <div class="row clearfix">
              <div class="col-lg-10 col-md-10 col-sm-12 gdpr-code-box">
                  <div class="row clearfix">
                      <div class="col-lg-7 col-md-12 col-sm-12 form-group">
                          <input type="text" class="form-control"  maxlength="16" minlength="16" placeholder="Please enter your code without spaces" name="name" [(ngModel)]="id" #name="ngModel" required  i18n-placeholder>
                      </div>
                      <div class="col-lg-5 col-md-12 col-sm-12 form-group">
                          <button class="btn btn-block btn-primary takeme-btn" (click)="getContactByHashCode()" i18n>Take me to my data preferences</button>
                      </div>
                  </div>
              </div>
          </div>
      </form>
      <!-- / End code validation section -->
  </div>
  <div class="col-md-12"><h2 class="gdpr-h2 title gdpr-h2-margin" i18n>Need assistance?</h2></div>
  <h3 class="gdpr-h3" i18n></h3>
  <div class=" col-md-12 gdpr-para"  i18n>Didn't receive a verification code? Questions? <br>Send an email to the <a href="mailto:data.preferences@ihsmarkit.com" style="text-decoration: none;">IHS Markit Support Team</a></div>
  <!-- Footer graphic -->  
</div>

<div class="my-container">
  <ngx-loading [show]="loading"></ngx-loading>
</div>


